import { render } from "./CurtirPressionado.vue?vue&type=template&id=4de5fc1a"
const script = {}
script.render = render

export default script